import { ref } from 'vue'
import { authApi } from '@/plugins/api'

export function useImpersonation() {
  const loading = ref(false)
  const error = ref<string | null>(null)

  async function impersonate(targetUserId: string): Promise<boolean> {
    loading.value = true
    error.value = null

    try {
      const response = await authApi.impersonate(targetUserId)
      const { impersonationToken } = response.data

      // Open new tab with activation URL
      const activateUrl = `${window.location.origin}/api/v1/auth/impersonate/activate?token=${impersonationToken}`
      window.open(activateUrl, '_blank')

      return true
    } catch (e: any) {
      console.error('Impersonation failed:', e)
      error.value = e.response?.data?.message || 'Не удалось выполнить вход'
      return false
    } finally {
      loading.value = false
    }
  }

  function endImpersonation() {
    // Simply close the tab
    window.close()
  }

  return {
    loading,
    error,
    impersonate,
    endImpersonation,
  }
}
